
















import '@bukalapak/bazaar-mweb/dist/bazaar.css'
import { V1OffsetPagination } from '@bukalapak/openapigen/products/mitrabangunan/transaction/v1/public'
import { toLower } from 'lodash'
import Vue, { PropType } from 'vue'
import SeoContent from '~/components/molecules/SeoContent.vue'
import CategorySlugContent from '~/components/organisms/category/slug/content.vue'
import Download from '~/components/organisms/LandingPage/Download/index.vue'
import { GlobalEvents } from '~/constants/pages/admin/global-events'
import { MainGlobalEvents } from '~/constants/pages/main-global-events'
import type { CategoryProduct } from '~/types/component/landing-product'
import { MappedPaginationType } from '~/types/component/mapped-pagination-type'
import { SeoContents } from '~/types/model/seo'
import errorToString from '~/utils/converter/error-to-string'

const defaultLimit = 30

const mapPagination = (pagination: V1OffsetPagination): MappedPaginationType => {
  const offset = pagination?.offset || 0
  const limit = pagination?.limit || defaultLimit
  const total = pagination?.total || 0

  return {
    currentPage: Math.ceil(offset / limit) + 1,
    limit,
    offset,
    total,
    totalPages: Math.ceil(total / limit),
  }
}

export default Vue.extend({
  name: 'CategorySlugPage',
  components: {
    CategorySlugContent,
    Download,
    SeoContent,
  },
  props: {
    level: {
      type: Number,
      required: true,
    },
    category: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    categorySlug: {
      type: String,
      required: true,
    },
    products: {
      type: Array as PropType<CategoryProduct[]>,
      required: true,
    },
    pagination: {
      type: Object as PropType<MappedPaginationType>,
      required: true,
    },
    contents: {
      type: Object as PropType<SeoContents>,
      required: true,
    },
  },
  data() {
    const defaultValueTracker = function () {
      return {
        started: 0,
        finished: 0,
      }
    }
    return {
      isFetching: false,
      section: {
        subCategory: defaultValueTracker(),
        productList: defaultValueTracker(),
        download: defaultValueTracker(),
        seo: defaultValueTracker(),
        footer: defaultValueTracker(),
      },
    }
  },
  computed: {
    isMobile(): boolean {
      return this.$viewport.match('mobile').valueOf()
    },
    page(): number {
      const { page } = this.$route.query
      return Number.parseInt(`${page}`, 10) || 1
    },
    offset(): number {
      return (this.page - 1) * defaultLimit
    },
  },
  watch: {
    '$route.query': {
      async handler() {
        await this.getListSellingProductOpenapi()
      },
    },
  },
  mounted() {
    this.$nuxt.$emit(MainGlobalEvents.HEADER_CONFIG, { screen: 'Category_Screen' })
    this.$nuxt.$emit(MainGlobalEvents.SCREEN_NAME, 'Category_Screen')
    this.trackVisit()
    if (process.client) {
      window.addEventListener('scroll', this.trackerEvent)
    }
  },
  beforeDestroy() {
    if (process.client) {
      window.removeEventListener('scroll', this.trackerEvent)
    }
  },
  methods: {
    trackVisit() {
      this.$tracker.track('app_screen_view', {
        screen_name: 'Category_Screen',
        screen_url: this.$route.fullPath,
        screen_referrer: document.referrer,
        screen_parameter: '',
        screen_status: '',
        screen_attribute: JSON.stringify({
          category_name: this.title,
        }),
      })
    },
    trackerEvent() {
      this.trackSectionVisited('subCategory', 'SubCategory_Section', 'c-category__banner')
      this.trackSectionVisited('productList', 'ProductList_Section', 'c-category__content')
      this.trackSectionVisited('download', 'DownloadApp_Section', 'c-download')
      this.trackSectionVisited('seo', 'ReadDetail_Section', 'c-seo')
      this.trackSectionVisited('footer', 'Footer_Section', 'c-footer__wrapper')
    },
    trackImpression(sectionName: string, duration: number) {
      this.$tracker.track('app_impression', {
        screen_name: 'Category_Screen',
        scroll_type: 'swipe-up',
        section_name: sectionName,
        item_name: '',
        duration,
        impression_attribute: JSON.stringify({}),
      })
    },
    trackSectionVisited(name: string, sectionName: string, className: string) {
      const { innerHeight } = window
      const elementComponent = document.querySelector(`.${className}`)
      const element = (elementComponent && elementComponent.getBoundingClientRect()) || null

      if (element && element.top < innerHeight && !this.section[name].started) {
        this.section[name].started = new Date().getTime()
      }

      if (element && element.bottom < innerHeight && !this.section[name].finished) {
        this.section[name].finished = new Date().getTime()
        const duration = this.section[name].finished - this.section[name].started
        this.trackImpression(sectionName, duration)
      }
    },
    async handlePageChange(page: number) {
      try {
        await this.$router.push({
          query: {
            page: `${page}`,
          },
        })
        if (!this.isMobile) {
          window.scrollTo({ top: 0 })
        }
      } catch (error) {
        this.$nuxt.$emit(GlobalEvents.MSG_ERROR, errorToString(error))
      }
    },
    async getListSellingProductOpenapi() {
      try {
        this.isFetching = true
        const params = {
          keyword: toLower(this.category?.category?.name || this.categorySlug).replace(/-/gi, ' '),
          offset: this.offset,
          limit: defaultLimit,
        }
        const { data } = await this.$api.sellingProductApi.sellingProductServiceListSellingProduct(params)
        if (data && data.selling_products?.length && data.meta?.offset_pagination) {
          let products: CategoryProduct[] = []
          const mappedProducts = data.selling_products!.map(product => ({
            name: product.name || '',
            image: product.image_urls?.length ? product.image_urls[0] : '',
          }))
          if (this.isMobile) {
            products = [...this.products, ...mappedProducts]
          } else {
            products = mappedProducts
          }
          this.$emit('update:products', products)
          this.$emit('update:pagination', mapPagination(data.meta?.offset_pagination!))
        }
      } catch (error) {
        this.$nuxt.$emit(GlobalEvents.MSG_ERROR, errorToString(error))
      } finally {
        this.isFetching = false
      }
    },
  },
})
